/**
 * Gets an api route from the given section.
 * @param  {string} section
 * @returns {string}
 */
import { getClassNameFromSectionModelUtil } from 'models/utils/get-class-name-from-section'
import getEndpointFromClassNameModelUtil from 'models/utils/get-endpoint-from-class-name'
import { SECTIONS_NAME } from 'modules/sections/constants/index.cjs'

function getEndpointFromSectionModelUtil (section) {
  if (section === SECTIONS_NAME.HOME) {
    return ''
  }
  if (section === SECTIONS_NAME.SEARCH) {
    return '/search'
  }
  const className = getClassNameFromSectionModelUtil(section)
  return getEndpointFromClassNameModelUtil(className)
}

export {
  getEndpointFromSectionModelUtil
}
